module.exports = __webpack_public_path__ + "static/media/sub_dropdown.a265a0c0.svg";